import { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const TagInput = ({
  values = [],
  onChange,
  placeholder = "Add value and press Enter",
  disabled = false,
}) => {
  const [draft, setDraft] = useState("");

  const commitDraft = () => {
    const trimmed = draft.trim();
    if (!trimmed) return;
    if (values.includes(trimmed)) {
      setDraft("");
      return;
    }
    onChange([...values, trimmed]);
    setDraft("");
  };

  const removeAt = (index) => {
    const next = values.slice();
    next.splice(index, 1);
    onChange(next);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commitDraft();
    } else if (e.key === "Backspace" && draft === "" && values.length > 0) {
      removeAt(values.length - 1);
    }
  };

  return (
    <div
      className={`flex flex-wrap gap-1.5 rounded-md border border-gray-300 bg-white px-2 py-1.5 shadow-xs focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500 ${
        disabled ? "opacity-60 pointer-events-none" : ""
      }`}
    >
      {values.map((value, i) => (
        <span
          key={`${value}-${i}`}
          className="inline-flex items-center gap-1 rounded-md bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700"
        >
          <span className="font-mono">{value}</span>
          <button
            type="button"
            onClick={() => removeAt(i)}
            className="text-indigo-500 hover:text-indigo-900"
            aria-label={`Remove ${value}`}
          >
            <XMarkIcon className="h-3.5 w-3.5" />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={commitDraft}
        placeholder={values.length === 0 ? placeholder : ""}
        className="flex-1 min-w-[120px] border-0 p-1 text-sm focus:outline-hidden focus:ring-0"
      />
    </div>
  );
};

export default TagInput;
